export const COOKIES = {
    visitor: 'KmxVisitor_0',
    customerAuthQA: 'Kmx_LQ',
    customerAuthPROD: 'Kmx_LP',
    authSession: 'KmxAuthSession',
    mxMyKmxInfo: 'KmxMyKmxInfo',
};

export const hasSignInAuthCookie = (): boolean => {
    try {
        const isProd = window.location.origin === 'https://www.carmax.com';
        const authCookieName = isProd ? COOKIES.customerAuthPROD : COOKIES.customerAuthQA;
        return !!document.cookie.includes(`${authCookieName}`);
    } catch (e) {
        return false;
    }
};
export const hasAuthSession = (): boolean => {
    try {
        const authSession = document.cookie.split(`${COOKIES.authSession}=`)[1].split(';')[0].split('tk=')[1];

        return authSession !== '' && authSession.length > 0;
    } catch (e) {
        return false;
    }
};

export const mxMyKmxInfoObject = (): any => createObjectFromCookie(COOKIES.mxMyKmxInfo);

const createObjectFromCookie = (cookieName: string) => {
    try {
        const cookieInfo = document.cookie.split(`${cookieName}=`)[1].split(';')[0];
        return splitCookieData(cookieInfo.split('&'));
    } catch (e) {
        return null;
    }
};

export const KmxVisitorObject = (): any => createObjectFromCookie(COOKIES.visitor);

function splitCookieData(data: any): any {
    if (data !== null) {
        let dataArray = new Map();
        dataArray = data.map((item: any) => [
            item.substring(0, item.indexOf('=')),
            item.substring(item.indexOf('=') + 1),
        ]);
        const cookieData = Object.fromEntries(dataArray);
        return cookieData;
    } else {
        return null;
    }
}

export const getStoreId = (): string | undefined => {
    return getCookieValue(COOKIES.visitor, 'StoreId');
};

export const getStoreZipCode = (): string | undefined => {
    return getCookieValue(COOKIES.visitor, 'Zip');
};

export const getStoreSearchZipCode = (): string | undefined => {
    return getCookieValue(COOKIES.visitor, 'StoreSearchZipCode');
};

export const getLatitude = (): number => {
    const latString = getCookieValue(COOKIES.visitor, 'Lat');
    let lat = 0;
    if (latString !== undefined) {
        lat = parseFloat(latString);
    }
    return lat;
};

export const getLongitude = (): number => {
    const longString = getCookieValue(COOKIES.visitor, 'Lon');
    let long = 0;
    if (longString !== undefined) {
        long = parseFloat(longString);
    }
    return long;
};

const getCookieValue = (cookieName: string, key: string): string | undefined => {
    const cookie = createObjectFromCookie(cookieName);
    return cookie?.[key];
};
